module.exports = __webpack_public_path__ + "static/img/picture_4.9644c8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new3/picture_4.jpg
// module id = hBoC
// module chunks = 2